// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Google
 *
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
export var PlayerState;
(function (PlayerState) {
    PlayerState[PlayerState["Buffering"] = 3] = "Buffering";
    PlayerState[PlayerState["Ended"] = 0] = "Ended";
    PlayerState[PlayerState["Paused"] = 2] = "Paused";
    PlayerState[PlayerState["Playing"] = 1] = "Playing";
    PlayerState[PlayerState["Unstarted"] = -1] = "Unstarted";
    PlayerState[PlayerState["VideoCued"] = 5] = "VideoCued";
})(PlayerState || (PlayerState = {}));
